import React from "react";

export const SomeText = (props: { text: string | JSX.Element }) => (
  <div className="popup-wrapper-sub-text">{props.text}</div>
);
